import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap-5';

import ListingSelectedProperty from '../selected_property';
import ListingLeaseInfo from '../lease_info';
import listingPropTypes from '../prop_types';

export default class TenantRepContractDetailsForm extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array,
    listing: listingPropTypes.isRequired,
    onChange: PropTypes.func.isRequired
  };

  handleAssignmentTypeChange = (event) => {
    const { checked, name } = event.target;
    this.props.onChange({
      leaseClosed: false,
      saleClosed: false,
      [name]: checked
    });
  }

  render() {
    return <React.Fragment>
      {this.renderAssignmentType()}
      <ListingSelectedProperty {...this.props} isAssignment />
      {this.renderLeaseInfo()}
    </React.Fragment>;
  }

  renderAssignmentType() {
    const { leaseClosed, saleClosed } = this.props.listing;

    return (
      <div className="form-group required mb-4">
        <label className="form-label">Assignment Type</label>
        <div className="d-flex gap-3">
          <Form.Check id="lease-assignment-type" type="radio">
            <Form.Check.Input
              checked={!!leaseClosed}
              name="leaseClosed"
              type="radio"
              onChange={this.handleAssignmentTypeChange}
            />
            <Form.Check.Label>Lease</Form.Check.Label>
          </Form.Check>
          <Form.Check id="sale-assignment-type" type="radio">
            <Form.Check.Input
              checked={!!saleClosed}
              name="saleClosed"
              type="radio"
              onChange={this.handleAssignmentTypeChange}
            />
            <Form.Check.Label>Sale</Form.Check.Label>
          </Form.Check>
        </div>
      </div>
    );
  }

  renderLeaseInfo() {
    const { listing, onChange } = this.props;

    if (listing.leaseClosed) {
      return (
        <ListingLeaseInfo listing={listing} onChange={onChange} />
      );
    }
  }
}
